const trackedActions = [
  "brain/modules/handleFilterChange",
  "brain/modules/resetSpecificFilterGroup", //geen action, gaat dat wel goed?
  // "brain/modules/resetAllFilters", //todo: implement this
  "brain/drivers/handleFilterChange",
  "brain/drivers/resetSpecificFilterGroup", //geen action, gaat dat wel goed?
  // "brain/drivers/resetAllFilters": //todo: implement this
];

export default function undo(store) {
  store.subscribeAction({
    before: (action) => {
      if (trackedActions.includes(action.type)) {
        if (action.payload.addToHistory === true) {
          store.commit("brain/history/addToHistory", action);
        }
      }
    },
  });
}
